import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tz/go/egaz/osci/ptl/comn";

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/manl`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/clntsport/manl/manl-mgmt`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    osci0107001q: `${BASE.path}/osci0107001q`, // Manage Manual information list !== 메뉴얼정보관리 목록 ==!
    osci0107002s: `${BASE.path}/osci0107002s`, // Manage manual information registration !== 매뉴얼정보관리 등록 ==!
    osci0107003s: `${BASE.path}/osci0107003s`, // Manage manual information registration !== 매뉴얼정보관리 등록 ==!
    // osci0112003s: `${BASE.path}/osci0112003s`, // Manage manual information Modifying !== 매뉴얼정보관리 수정 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Get a list of manual information. !== 매뉴얼정보 목록을 조회한다. ==!
    getManlList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // Select manual details !== 매뉴얼 상세 정보 조회 ==!
    getManlInfo: (scrnId: any) => {
        return api.get(`${BASE.api}/${scrnId}`);
    },
    // Create manual information !== 매뉴얼 정보 생성 ==!
    createManlInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // Update manual information !== 매뉴얼 정보 수정 ==!
    updateManlInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    // Delete manual information !== 매뉴얼 정보 삭제 ==!
    deleteManlInfo: (scrnId: any) => {
        return api.delete(`${BASE.api}/${scrnId}`);
    },

    // Get a Screen information. !== 화면 정보를 조회한다. ==!
    getScrnInfo: (scrnId: any) => {
        return api.get(`${BASE.api}/scrn/${scrnId}`);
    },
};

export const SF_MANL_INFO_SEARCH_FORM: TFormSchema = {
    id: "form_infoSrch",
    schema: {
        /* Business Type !== 업무분류 ==!*/
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            area: "comnCd",
            comnCd: "OSC0088",
            select: false,
            defaultValue: "OSC",
        },
        ptlTpCd: {
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B", "I", "E"],
        },
        scrnId: {
            type: "text",
            label: "L_SCRN_ID",
        },
        scrnNm: {
            type: "text",
            label: "L_SCRN_NM",
        },
    },
};

export const SF_MANL_INFO_FORM: TFormSchema = {
    id: "form_manlInfo",
    schema: {
        scrnId: { type: "text", label: "L_SCRN_ID" },
        scrnNm: { type: "text", label: "L_SCRN_NM", edit: false },
        bsopClsfCd: {
            type: "select",
            label: "L_BSOP_CLSF_NM",
            edit: false,
            required: true,
            area: "comnCd",
            comnCd: "OSC0088",
        },
        ptlTpCd: {
            type: "select",
            label: "L_PTL_TP_CD",
            edit: false,
            required: true,
            area: "comnCd",
            comnCd: "OSC0095",
        },
        manlFileIdKo: {
            type: "file",
            label: "L_MANL_FILE_ID_KO",
            edit: true,
            bsopClsfCd: "OSC",
            accept: ".pdf",
            isPublic: true,
        },
        manlFileIdEn: {
            type: "file",
            label: "L_MANL_FILE_ID_EN",
            edit: true,
            bsopClsfCd: "OSC",
            accept: ".pdf",
            isPublic: true,
        },
        manlFileIdTz: {
            type: "file",
            label: "L_MANL_FILE_ID_TZ",
            edit: true,
            bsopClsfCd: "OSC",
            accept: ".pdf",
            isPublic: true,
        },
    },
};

export const SG_MANL_INFO_LIST: TGridSchema = {
    id: "grid_manlInfoList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_SCRN_ID", binding: "scrnId", width: "15%" }], id: "scrnId" },
        { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: "*" }], id: "scrnNm" },
        { cells: [{ header: "L_BSOP_CLSF_NM", binding: "bsopClsfCdNm", width: "15%" }], id: "bsopClsfCd" },
        { cells: [{ header: "L_PTL_TP_CD", binding: "ptlTpCdNm", width: "15%" }], id: "ptlTpCd" },
    ],
    body: [
        {
            cells: [{ binding: "scrnId" }],
        },
        {
            cells: [{ binding: "scrnNm", align: "left" }],
        },
        {
            cells: [{ binding: "bsopClsfCdNm" }],
        },
        {
            cells: [{ binding: "ptlTpCdNm" }],
        },
    ],
};

export const SF_MENU_SCRN_SRCH: TFormSchema = {
    id: "form_menuScrnSrch",
    schema: {
        bsopClsfCd: {
            required: true,
            type: "select",
            label: "L_BSOP_CLSF_CD",
            area: "comnCd",
            comnCd: "OSC0088",
            excludes: ["COM"],
            defaultValue: "OSC",
        },
        ptlTpCd: {
            required: true,
            type: "select",
            label: "L_PTL_TP_CD",
            area: "comnCd",
            comnCd: "OSC0095",
            excludes: ["B", "I", "E"],
            defaultValue: "O",
        },
        scrnId: { type: "text", label: "L_SCRN_ID", letterCase: "lower" },
        scrnNm: { type: "text", label: "L_SCRN_NM" },
        menuId: { type: "text" },
        menuPath: { type: "text", edit: false, label: "L_MENU_PATH" },
    },
};

export const SG_SCRN_LIST: TGridSchema = {
    id: "grid_scrnList",
    options: { index: true, pagination: "out", height: 400 },
    head: [
        { cells: [{ header: "L_SCRN_ID", binding: "scrnId", width: 150 }] },
        { cells: [{ header: "L_SCRN_NM", binding: "scrnNm", width: 200 }] },
        { cells: [{ header: "L_SCRN_URL_ADDR", binding: "scrnUrlAddr", width: 200 }] },
        { cells: [{ header: "L_SCRN_DESC", binding: "scrnDesc", width: "*" }] },
        { show: false, cells: [{ binding: "chkYn" }] },
        { show: false, cells: [{ binding: "menuCnctYn" }] },
        { show: false, cells: [{ binding: "menuId" }] },
    ],
    body: [
        { cells: [{ binding: "scrnId" }] },
        { cells: [{ binding: "scrnNm", align: "left" }] },
        { cells: [{ binding: "scrnUrlAddr", align: "left" }] },
        { cells: [{ binding: "scrnDesc", align: "left" }] },
        { cells: [{ binding: "chkYn" }] },
        { cells: [{ binding: "menuCnctYn" }] },
        { cells: [{ binding: "menuId" }] },
    ],
};
